import { useEffect, useState } from 'react';
import { Groupper, Button, Input, Field, Message, Table } from 'react-frontier';
import { useBreadcrumbs } from '../hooks';
import { EventsReportSummary, SetLoading } from '../SiteClasses';
import { addCommas } from '../SiteUtil';
import API from '../API';
import Validator from '../Validator';
import moment from 'moment';

var EventsReport = ()=>{
	var { setTitle } = useBreadcrumbs();
	var [startDate, setStartDate] = useState<number>(null);
	var [endDate, setEndDate] = useState<number>(null);
	var [errorPrompts, setErrorPrompts] = useState<string[]>([]);
	var [summary, setSummary] = useState<EventsReportSummary>(null);

	useEffect(()=>{
		setTitle('Reporte de eventos');
	}, []);

	var searchReport = async(setLoading: SetLoading)=>{
		var { valid, prompts } = Validator({ startDate, endDate }, {
			startDate: [{ rule: 'number', label: 'Fecha inicio' }],
			endDate: [{ rule: 'number', label: 'Fecha fin' }]
		});
		setErrorPrompts(prompts);
		if(!valid) return;
		if(endDate <= startDate) return setErrorPrompts(['La fecha de fin debe ser mayor que la fecha de inicio']);

		var dateStart = moment.unix(startDate).startOf('day').unix();
		var dateEnd = moment.unix(endDate).endOf('day').unix();

		setLoading(true);
		setSummary(null);
		API.getEventsReportSummary(dateStart, dateEnd).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
			if(!res.data || res.data.total_records === 0) return setErrorPrompts(['No se encontró información con las fechas seleccionadas']);
			setErrorPrompts([]);
			setSummary(res.data);
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado (EVT-RPT-2)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var downloadReport = async(setLoading: SetLoading)=>{
		var dateStart = moment.unix(startDate).startOf('day').unix();
		var dateEnd = moment.unix(endDate).endOf('day').unix();

		setLoading(true);
		API.downloadEventsReport(dateStart, dateEnd).then(res=>{
			if(res.error) return setErrorPrompts([res.message]);
		}).catch(err=>{
			setErrorPrompts(['Hubo un error inesperado (EVT-RPT-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	return <div>
		<Groupper title='Reporte de eventos' width={500} style={{ marginTop: 20 }} actions={<>
			<Button text='Descargar' color='green' iconName='download' onClick={downloadReport} disabled={!summary} />
			<Button text='Buscar' color='black' onClick={searchReport} />
		</>}>
			<Field amount={2}>
				<Input 
					label='Fecha de inicio' 
					value={startDate} 
					onChange={setStartDate}
					style={{ width: '100%'}}
					calendar={{ 
						date: moment().subtract(30, 'd').startOf('day').unix(), 
						mode: 'date', 
						format: 'DD/MM/YYYY' 
					}} 
				/>
				<Input 
					label='Fecha de fin' 
					value={endDate}
					style={{ width: '100%'}}
					onChange={setEndDate} 
					calendar={{ 
						date: moment().endOf('day').unix(), 
						mode: 'date', 
						format: 'DD/MM/YYYY' 
					}} 
				/>
			</Field>
			<Message list={errorPrompts} type={'error'} />
		</Groupper>
		{summary && (
			<Table
				details
				striped
				title='Resumen'
				style={{ maxWidth: 500, margin: 'auto', marginTop: 15, marginBottom: 15 }}
				data={[
					['Registros', summary.total_records],
					['Eventos', summary.total_events],
					['Liquidaciones', summary.total_payouts],
					['Trabajadores', summary.total_workers],
					['Coordinadores', summary.total_coordinators],
					null,
					[<b>Total</b>, <b>{'$' + addCommas(summary.total_amount)}</b>],
				]}
			/>
		)}
	</div>
}

export default EventsReport;
